import { z } from 'zod';

const emailValidationMessage = 'Enter a valid email address';
export const emailValidationSchema = z
  .string({ required_error: emailValidationMessage })
  .email({ message: emailValidationMessage });

export const optionalEmailValidationSchema = emailValidationSchema.or(
  z.literal(''),
);
